
var bindTablesorter = function(selector, extraOptions, extraWidgetOptions, suffix, filter) {
  $.extend($.tablesorter.themes.bootstrap, {
    // these classes are added to the table. To see other table classes available,
    // look here: http://twitter.github.com/bootstrap/base-css.html#tables
    table      : 'table table-bordered',
    //header     : 'bootstrap-header', // give the header a gradient background
    header     : 'mtggoldfish-bootstrap-header', // give the header a gradient background
    footerRow  : '',
    footerCells: '',
    icons      : '', // add "icon-white" to make them white; this icon class is added to the <i> in the header
//    sortNone   : 'bootstrap-icon-unsorted',
//    sortAsc    : 'glyphicon glyphicon-chevron-up',
//    sortDesc   : 'glyphicon glyphicon-chevron-down',
    iconSortNone : 'fas fa-sort', // class name added to icon when column is not sorted
    iconSortAsc  : 'fas fa-sort-up', // class name added to icon when column has ascending sort
    iconSortDesc : 'fas fa-sort-down', // class name added to icon when column has descending sort
    active     : '', // applied when column is sorted
    hover      : '', // use custom css here - bootstrap class may not override it
    filterRow  : '', // filter row class
    even       : '', // odd row zebra striping
    odd        : ''  // even row zebra striping
  });


  var columnSelector = "#columnSelector";
  if (suffix && 0 != suffix.length) {
    columnSelector = columnSelector + '-' + suffix;
  }

  var widgetOptions = { 
    zebra : ["even", "odd"],
    filter_childRows  : true,
    filter_cssFilter  : 'tablesorter-myfilter',
    filter_startsWith : false,
    filter_ignoreCase : true,

    columnSelector_container : $(columnSelector),
    columnSelector_columns : {
      0: 'disable' /* set to disabled; not allowed to unselect it */
    },

    columnSelector_saveColumns: false,
    columnSelector_layout : '<label class="tablesorter-filter-popover-label"><input class="tablesorter-filter-popover-input" type="checkbox">{name}</label>',
    columnSelector_name  : 'data-selector-name',
    columnSelector_mediaquery: true,
    columnSelector_mediaqueryName: 'Auto',
    columnSelector_mediaqueryState: true,
    columnSelector_breakpoints : [ '20em', '30em', '40em', '50em', '60em', '70em' ],
    columnSelector_priority : 'data-priority'
  };
  var widgets = ['uitheme', 'zebra', 'columnSelector'];
  if (filter) {
    widgets.push('filter');
  }
  var options = {
    theme: 'bootstrap',
    //widthFixed: true,
    widgets : widgets,
    headerTemplate : '{content} {icon}', // new in v2.7. Needed to add the bootstrap icon!
    widgetOptions: $.extend(widgetOptions, extraWidgetOptions)
  };
  selector.tablesorter($.extend(options, extraOptions));
};

var bindTablesorterPopover = function(suffix) {
  var append = "";
  if (suffix && suffix.length != 0) {
    var append = "-" + suffix;
  }
  $('.tablesorter-filter-popover' + append)
    .popover({
      placement: 'right',
      html: true, // required if content has HTML
      content: '<div id="popover-target' + append + '"></div>'
    })
    // bootstrap popover event triggered when the popover opens
    .on('shown.bs.popover', function () {
      // call this function to copy the column selection code into the popover
      $.tablesorter.columnSelector.attachTo( $('.tablesorter-bootstrap-popover' + append), '#popover-target' + append);
      $('.popover').css('top',parseInt($('.popover').css('top')) - 65 + 'px');
    });
};

$(function(){
  bindTablesorterPopover('');
  bindTablesorterPopover('online');
  bindTablesorterPopover('paper');
});

window.bindTablesorter = bindTablesorter
window.bindTablesorterPopover = bindTablesorterPopover
